<template>
<list
  :heading="heading"
  :description="description"
  model="herd"
  :items="herds"
  :status="status"
  :nextUrl="nextUrl"
  @onFetchMore="updateItems"
>
  <HerdCard
    :key="item.id"
    v-for="item in herds"
    :user="user"
    :item="item"
    @removed="removeItem"
  />
</list>
</template>

<script>
import {mapState} from 'vuex';
import List from '../../layouts/List/List';
import HerdCard from '../../components/HerdCard/HerdCard';

export default {
  name: 'HerdList',
  data() {
    return {
      errors: [],
      num: 12
    };
  },
  components: {
    HerdCard,
    List
  },
  mounted() {
    if (this.herds.length <= this.num) {
      this.$store.dispatch('herd/FETCH_ALL', {
        num: this.num
      });
    }
  },
  computed: {
    ...mapState({
      user: state => state.currentUser.currentUser,
      authenticated: state => state.currentUser.authenticated,
      heading: state => state.herd.heading,
      description: state => state.herd.description,
      status: state => state.herd.status,
      nextUrl: state => state.herd.nextUrl
    }),
    herds() {
      return this.$store.getters['herd/getAll'];
    }
  },
  methods: {
    updateItems() {
      this.$store.dispatch('herd/FETCH_MORE');
    },
    removeItem(payload) {
      this.$store.dispatch('herd/REMOVE', payload)
    }
  }
};
</script>
